import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import usePageNav from '../hooks/usePageNav';
import ArticleList from './ArticleList';
import PageNavCurPageIndicator from './PageNavCurPageIndicator';
import PageNav from './PageNav';
import { Container } from 'react-bootstrap';
import getNavigationInitialState from '../initialState/navigation';
import { LoadingContext } from './context/LoadingContext';
import SEO from './SEO';
import AppContext from './context/AppContext';
import { bool } from 'prop-types';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';

/**
 * CONFIGURATION
 */

const MAX_LIMIT_PER_PAGE = 25;

export default function BlogNews({ isMobile }) {
    const { appContext } = useContext(AppContext);
    const articlePath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.ARTICLE_PATH });
    const [blogLoaded, setBlogLoaded] = useState();
    const [blogData, setBlogData] = useState([]);
    // Loading state
    const {
        startLoading,
        finishLoading,
    } = useContext(LoadingContext);
    /* Pagination code */
    const containerRef = useRef(null);
    const [pagesData, setPagesData] = useState(getNavigationInitialState());
    const {
        curPage,
        curRange,
        nextRange,
        generatedPagesData,
        paginateUser,
    } = usePageNav({ containerRef,
        pagesData });
    /* End pagination code */
    const fetchBlogList = useCallback(async () => {
        try {
            const params = new URLSearchParams({
                page: curPage,
                limit: MAX_LIMIT_PER_PAGE,
            }).toString();
            startLoading();
            const response = await fetch(new URL(`api/articles?${params}`, process.env.APP_URL), {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            finishLoading();
            const data = await response.json();
            if (data.articles) {
                setBlogData(data.articles);
            } else {
                setBlogData([]);
            }
            if (data.pageInfo) {
                setPagesData({
                    limit: data.pageInfo.limitPerPage,
                    count: data.pageInfo.totalObjects,
                    pages: data.pageInfo.totalPages,
                });
            }
            setBlogLoaded(true);
        } catch (e) {
            console.error(e);
            finishLoading();
        }
    }, [curPage, startLoading, finishLoading]);
    useEffect(() => {
        setBlogLoaded(false);
        setPagesData({});
        setBlogData([]);
        fetchBlogList();
    }, [fetchBlogList]);
    return (<Container
        fluid>
        <div
            className={'page--section'}
            style={{ padding: '0' }}>
            {blogLoaded === true && (<>
                <SEO
                    seoTitle={'Blog Posts - ' + appContext.config.storeName}
                    seoType={'website'}
                    canonicalUrl={new URL(`${articlePath[0].pathBeforeParams}/`, process.env.APP_URL).toString()}
                />
                <PageNavCurPageIndicator
                    curRange={curRange}
                    nextRange={nextRange}
                    totalCount={pagesData.count}
                    resourceType={'articles'}
                />
                <ArticleList
                    isMobile={isMobile}
                    isPage={true}
                    articles={blogData} />
                <PageNav
                    curPage={curPage}
                    totalPages={pagesData.pages}
                    generatedPagesData={generatedPagesData}
                    paginateUser={paginateUser}
                />
            </>)}
        </div>
    </Container>);
}

BlogNews.propTypes = {
    isMobile: bool,
};